import React from "react";

import { TestWrapper } from "@ui/Atoms/TestWrapper";

import { PropsWithClassName } from "./BentoBox.types";
import * as Styled from "./BentoBox.styled";

type BentoBox = {
  (props: React.PropsWithChildren<PropsWithClassName>): React.ReactElement;
  Image: typeof Styled.Image;
};

/**
 * @param children - The customizable background of the BentoBox
 */
export const BentoBox: BentoBox = props => (
  <TestWrapper testId={props.testId}>
    <Styled.Root
      className={props.className}
      $variant={props.variant}
      $color={props.color}
      $backgroundColor={props.backgroundColor}
    >
      {!!props.href && (
        <Styled.AnchorOverlay
          href={props.href}
          target={props.target}
          onClick={props.onClick}
        />
      )}

      <Styled.Body>
        {props.label && <Styled.Label>{props.label}</Styled.Label>}

        <Styled.Heading>{props.heading}</Styled.Heading>

        {props.description && (
          <Styled.Description>{props.description}</Styled.Description>
        )}

        {!!props.cta && <Styled.CTA>{props.cta}</Styled.CTA>}
      </Styled.Body>

      {!!props.children && (
        <Styled.BackgroundContainer>
          {props.children}
        </Styled.BackgroundContainer>
      )}
    </Styled.Root>
  </TestWrapper>
);

BentoBox.Image = Styled.Image;
